import axios from 'axios'

class UserTypeService {
  constructor (apiUrl) {
    this.apiUrl = apiUrl
  }

  /**
  * @author Leonel Contreras
  * @description Handle event to get the user information from auth0
  * @date 20-07-2020
  * @param {Object} authOId
  * @param {String} token
  * @returns {Object}
  * @memberof UserTypeService
  */
  async getUsersType (token) {
    let response = await axios.get(`${this.apiUrl}/users-type`, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    })
    return response.data.data
  }
  

}

export { UserTypeService as default }
